// P29.20 Plausible analytics helper. Shared trackEvent fn so every call site
// (HeroSection, PricingTiers, LanguageToggle, FaqAccordion, footer CTA,
// signup form per P29.21) goes through the same null-safe code path.
// Window.plausible global is also declared here so component files don't
// have to redeclare it.

declare global {
  interface Window {
    plausible?: (event: string, options?: { props?: Record<string, string> }) => void;
  }
}

export function trackEvent(eventName: string, props?: Record<string, string>) {
  if (typeof window === 'undefined') return;
  if (typeof window.plausible !== 'function') return;
  window.plausible(eventName, props ? { props } : undefined);
}
